var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32213_212288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9337 34.5501L33.0745 29.2892L23.9337 24.0283L14.793 29.2892L23.9337 34.5501Z",
    fill: "url(#paint0_linear_32213_212288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0744 29.2894V18.7677L23.9336 13.5068V24.0286L33.0744 29.2894Z",
    fill: "url(#paint1_linear_32213_212288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9337 13.5068L14.793 18.7677V29.2894L23.9337 24.0286V13.5068Z",
    fill: "url(#paint2_linear_32213_212288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0744 18.7676L23.9336 34.5502V24.0284L33.0744 18.7676Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0745 18.7676L23.9337 24.0284L14.793 18.7676H33.0745Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32213_212288",
    x1: 23.9337,
    y1: 24.0283,
    x2: 23.9337,
    y2: 34.5501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32213_212288",
    x1: 33.0744,
    y1: 18.8001,
    x2: 23.9336,
    y2: 24.1601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32213_212288",
    x1: 23.9337,
    y1: 13.5068,
    x2: 14.793,
    y2: 29.2894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32213_212288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1304,
    height: 22,
    fill: "white",
    transform: "translate(14.4346 13.0283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/Cursor.30f1e512f810079fdd79ff1a41c667bc.svg";
export { ForwardRef as ReactComponent };